module.exports = __webpack_public_path__ + "img/genecologie_ obstetrique.791d1a33.png";